<template>
  <v-card @click="() => emit('click')" class="rounded-lg bg-background">
    <v-card-title class="d-flex justify-space-between text-subtitle-1 font-weight-medium">
      <div class="text-truncate flex-grow-1 flex-shrink-1">
        {{ vehicle.name ?? 'unnamed vehicle' }}
      </div>
      <v-btn
        v-if="canDeleteVehicle"
        icon
        density="compact"
        color="transparent"
        flat
        class="flex-shrink-0 flex-grow-0"
        @click.stop="deleteVehiclePreCheck"
      >
        <v-icon color="grey" size="small">custom:deleteIcon</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle class="font-weight-medium pr-12">
      {{ vehicle.licensePlate ?? 'unrecorded license plate' }}
    </v-card-subtitle>
    <v-card-text v-if="vehicle.fuelType === 'Electric' || vehicle.fuelType === 'Plug in hybrid'">
      <NotConnectedBatteryDisplay v-if="!vehicle.stateOfCharge" />
      <BatteryDisplay v-else :battery="vehicle.stateOfCharge" />
      {{ vehicle.fuelType ? vehicle.fuelType : 'Electric' }}
    </v-card-text>
    <AlertPopupWindow 
        :activator="showDeleteVehicleAlert"
        :title="deleteVehicleAlertDetails.title"
        :message="deleteVehicleAlertDetails.message"
        @close="
          () => {
            showDeleteVehicleAlert = false
          }
        "
        @after-leave="() => {}"
        @do-not-show-again="
          () => {
            toggleDoNotShowAgain(true)
          }
        "
        @show-again="
          () => {
            toggleDoNotShowAgain(false)
          }
        "
        @continue="deleteVehicle"
    />
  </v-card>
</template>

<script lang="ts" setup>
import { PermissionKeys } from '@/classes/user_classes/essentialsPermissionsControl'
import Vehicle from '@/classes/vehicle_classes/vehicle'
import { deleteVehicleAlertData } from '@/data/const'
import { GettersTypes, MutationTypes, type State } from '@/store/store_types'
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import AlertPopupWindow from '../alert-popup/AlertPopupWindow.vue'
import BatteryDisplay from '../ui-elements/displays/BatteryDisplay.vue'
import NotConnectedBatteryDisplay from '../ui-elements/displays/NotConnectedBatteryDisplay.vue'

const { vehicle } = defineProps<{ vehicle: Vehicle }>()
const emit = defineEmits(['click'])

const deleteVehicleAlertDetails = ref(deleteVehicleAlertData)
const showDeleteVehicleAlert = ref(false)
const store = useStore<State>()
const canDeleteVehicle = computed(() => {
  let canDelete = false
  const permissions = store.state.permissions
  if (permissions?.get(PermissionKeys.canDeleteVehicles)) {
    canDelete = true
  } else if (vehicle.created_by && permissions?.get(PermissionKeys.canDeleteVehicles) && vehicle.created_by === store.getters[GettersTypes.getCurrentUser].id) {
    canDelete = true
  }
  return canDelete
})
const DSA_delete_vehicle_warning = computed(() => store.state.DSA_delete_vehicle_warning)
function toggleDoNotShowAgain(value:boolean){
  store.commit(MutationTypes.setDSA_delete_vehicle_warning, value)
}
function deleteVehiclePreCheck() {
  if (DSA_delete_vehicle_warning.value) {
    deleteVehicle()
  } else {
    showDeleteVehicleAlert.value = true
  }
}

function deleteVehicle() {}
</script>
